/**
 * Códigos de agencia del ISRC (los dos primeros caracteres) que asignó la IFPI.
 *
 * No son códigos de país de ISO 3166: la IFPI asigna los suyos (QM, QZ y QT son
 * de Estados Unidos, UK y GX del Reino Unido, VV es la asignación automática) y
 * no asignó todos los de ISO (VI, GU o KP no están). Un código que no figura
 * acá es un aviso, no un error: la lista crece todos los años y un código nuevo
 * y legítimo no se puede frenar hasta que la actualicemos.
 *
 * Para actualizarla: bajar el PDF de IFPI_AGENCY_CODES_SOURCE, cambiar la lista
 * y la fecha, y ajustar el total en el test.
 *
 * ESPEJO byte-idéntico: jupiter-server/src/common/validation/identifiers/ifpiAgencyCodes.ts
 * y jupiter-client/src/entities/common/validation/identifiers/ifpiAgencyCodes.ts
 */

/** Mes de la lista publicada por la IFPI. Se muestra en el aviso. */
export const IFPI_AGENCY_CODES_DATE = "2026-01";

export const IFPI_AGENCY_CODES_SOURCE =
  "https://isrc.ifpi.org/images/downloads/Valid-Characters-in-the-ISRC-Prefix.pdf";

export const IFPI_AGENCY_CODES: ReadonlySet<string> = new Set([
  "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AR", "AT", "AU", "AW",
  "AZ", "BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK",
  "BM", "BN", "BO", "BP", "BR", "BS", "BT", "BW", "BX", "BY", "BZ", "CA",
  "CB", "CD", "CF", "CG", "CH", "CI", "CL", "CM", "CN", "CO", "CP", "CR",
  "CS", "CU", "CV", "CW", "CY", "CZ", "DE", "DG", "DJ", "DK", "DM", "DO",
  "DZ", "EC", "EE", "EG", "ER", "ES", "ET", "FI", "FJ", "FO", "FR", "FX",
  "GA", "GB", "GD", "GE", "GG", "GH", "GI", "GL", "GM", "GN", "GQ", "GR",
  "GT", "GW", "GX", "GY", "HK", "HN", "HR", "HT", "HU", "ID", "IE", "IL",
  "IM", "IN", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG",
  "KH", "KM", "KN", "KR", "KS", "KW", "KY", "KZ", "LA", "LB", "LC", "LI",
  "LK", "LR", "LS", "LT", "LU", "LV", "MA", "MC", "MD", "ME", "MF", "MG",
  "MK", "ML", "MM", "MN", "MO", "MP", "MR", "MS", "MT", "MU", "MV", "MW",
  "MX", "MY", "MZ", "NA", "NE", "NG", "NI", "NL", "NO", "NP", "NZ", "OM",
  "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PR", "PS", "PT", "PY", "QA",
  "QM", "QN", "QR", "QT", "QZ", "RO", "RS", "RU", "RW", "SA", "SB", "SC",
  "SD", "SE", "SG", "SI", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST",
  "SV", "SX", "SY", "SZ", "TC", "TD", "TG", "TH", "TL", "TN", "TO", "TR",
  "TT", "TW", "TZ", "UA", "UG", "UK", "US", "UY", "UZ", "VC", "VE", "VG",
  "VN", "VU", "VV", "XK", "YE", "YU", "ZA", "ZB", "ZM", "ZW", "ZZ",
]);
